"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * return the next day of selected Date.
 * @param {Date Object} day
 * @returns {Date Object}
 */
function getNextDay(date) {
  var noOfDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextDay = new Date(date);
  return (0, _addDays["default"])(nextDay, noOfDay);
}
var _default = exports["default"] = getNextDay;